import { createStore, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import DEALERS_STATE from "./dealers.json";

const newShuffleKey = () => Math.round(Math.random() * 1000);
const INITIAL_FORM_STATE = {
	selectedTags: [],
	textSearch: "",
	shuffleSeed: newShuffleKey(),
};
const form = (state = INITIAL_FORM_STATE, action) => {
	switch (action.type) {
		case "SET_TEXT_SEARCH":
			return {
				...state,
				shuffleSeed: newShuffleKey(),
				textSearch: action.payload,
			};
		case "SET_SELECTED_TAGS":
			return {
				...state,
				selectedTags: action.payload,
				shuffleSeed: newShuffleKey(),
			};
		default:
			return state;
	}
};
const dealers = (state = DEALERS_STATE, action) => {
	return state;
};

const store = createStore(
	combineReducers({
		form,
		dealers,
	}),
	applyMiddleware(logger)
);

export default store;
